// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__2AeeY","Div":"CustomFadeBox_Div__1qssO"};